/**
 * Rooftop Sky Bar — overhauled bar, bartender NPC "Rio", and lounge deck.
 * All positions are fractions of W so desktop + mobile both lay out cleanly.
 */

export const drawRooftopFurniture = (ctx, W, H, floorY, phase) => {
  const furnitureY = floorY + 60;
  const glow = 0.55 + Math.sin(phase * 0.04) * 0.35;

  // === LOUNGE DECK (left) ===
  const drawLounger = (x) => {
    ctx.save();
    ctx.translate(x, furnitureY);
    ctx.fillStyle = 'rgba(0,0,0,0.35)';
    ctx.beginPath(); ctx.ellipse(0, 34, 40, 8, 0, 0, Math.PI * 2); ctx.fill();
    // wooden frame + legs
    ctx.fillStyle = '#3b2a1a';
    ctx.fillRect(-34, 26, 68, 6);
    ctx.fillRect(-30, 30, 6, 8); ctx.fillRect(24, 30, 6, 8);
    // seat
    ctx.fillStyle = '#6d28d9';
    ctx.fillRect(-32, 14, 58, 14);
    // reclined back with pillow
    ctx.save();
    ctx.translate(-32, 14);
    ctx.rotate(-0.6);
    ctx.fillStyle = '#7c3aed';
    ctx.fillRect(0, -12, 34, 12);
    ctx.fillStyle = '#a78bfa';
    ctx.fillRect(2, -10, 30, 4);
    ctx.restore();
    // cushion stripes
    ctx.fillStyle = 'rgba(255,255,255,0.15)';
    for (let i = 0; i < 4; i++) ctx.fillRect(-28 + i * 14, 15, 6, 12);
    ctx.restore();
  };
  drawLounger(W * 0.13);
  drawLounger(W * 0.27);
  // side table with a drink
  const tx = W * 0.2;
  ctx.fillStyle = '#2a2a34';
  ctx.fillRect(tx - 3, furnitureY + 8, 6, 24);
  ctx.fillStyle = '#3a3a46';
  ctx.beginPath(); ctx.ellipse(tx, furnitureY + 8, 16, 5, 0, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = '#f472b6';
  ctx.fillRect(tx - 3, furnitureY - 2, 6, 8);

  // === SKY BAR (right) ===
  const barX = W * 0.79;

  // backdrop panel — dims the skyline so the bar reads clearly
  ctx.fillStyle = 'rgba(10, 8, 20, 0.88)';
  ctx.fillRect(barX - 100, furnitureY - 150, 200, 128);
  ctx.strokeStyle = `rgba(103,232,249,${glow * 0.7})`;
  ctx.lineWidth = 2;
  ctx.strokeRect(barX - 100, furnitureY - 150, 200, 128);

  // neon SKY BAR sign on the panel
  ctx.font = 'bold 17px monospace';
  ctx.textAlign = 'center';
  ctx.fillStyle = '#67e8f9';
  ctx.shadowColor = '#67e8f9';
  ctx.shadowBlur = 14 * glow;
  ctx.fillText('S K Y  B A R', barX, furnitureY - 128);
  ctx.shadowBlur = 0;

  // back shelves with glowing bottles
  const bottleColors = ['#2ecc71', '#e74c3c', '#3498db', '#f39c12', '#9b59b6', '#67e8f9'];
  [0, 1].forEach((row) => {
    const sy = furnitureY - 112 + row * 30;
    ctx.fillStyle = '#241c30';
    ctx.fillRect(barX - 88, sy + 18, 176, 5);
    for (let i = 0; i < 6; i++) {
      const bxx = barX - 78 + i * 28;
      const c = bottleColors[(i + row * 2) % bottleColors.length];
      ctx.fillStyle = c;
      ctx.shadowColor = c;
      ctx.shadowBlur = 6;
      ctx.fillRect(bxx, sy - 2, 8, 20);
      ctx.fillRect(bxx + 2, sy - 8, 4, 7);
      ctx.shadowBlur = 0;
    }
  });

  // pendant lights
  [-55, 0, 55].forEach((off, i) => {
    const lx = barX + off;
    ctx.strokeStyle = '#3a3a46';
    ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(lx, furnitureY - 150); ctx.lineTo(lx, furnitureY - 58); ctx.stroke();
    const la = 0.6 + Math.sin(phase * 0.05 + i) * 0.3;
    ctx.fillStyle = `rgba(253, 224, 71, ${la})`;
    ctx.shadowColor = '#fde047';
    ctx.shadowBlur = 12;
    ctx.beginPath(); ctx.arc(lx, furnitureY - 54, 5, 0, Math.PI * 2); ctx.fill();
    ctx.shadowBlur = 0;
  });

  // counter with granite-wood top + neon under-strip
  ctx.fillStyle = '#17131f';
  ctx.fillRect(barX - 92, furnitureY - 24, 184, 36);
  const topGrad = ctx.createLinearGradient(barX - 96, 0, barX + 96, 0);
  topGrad.addColorStop(0, '#4c3a2c');
  topGrad.addColorStop(0.5, '#8a6a4d');
  topGrad.addColorStop(1, '#4c3a2c');
  ctx.fillStyle = topGrad;
  ctx.fillRect(barX - 98, furnitureY - 30, 196, 9);
  ctx.fillStyle = `rgba(103,232,249,${glow})`;
  ctx.shadowColor = '#67e8f9';
  ctx.shadowBlur = 10;
  ctx.fillRect(barX - 92, furnitureY + 9, 184, 3);
  ctx.shadowBlur = 0;

  // glasses on the counter
  ctx.fillStyle = 'rgba(255,255,255,0.35)';
  ctx.fillRect(barX - 60, furnitureY - 40, 6, 11);
  ctx.fillRect(barX + 44, furnitureY - 38, 5, 9);
  ctx.fillStyle = '#f472b6';
  ctx.fillRect(barX + 60, furnitureY - 39, 6, 10);

  // stools
  const drawStool = (sx) => {
    ctx.fillStyle = '#3a3a46';
    ctx.fillRect(sx - 3, furnitureY + 16, 6, 22);
    ctx.fillStyle = '#1f1a2a';
    ctx.beginPath(); ctx.ellipse(sx, furnitureY + 16, 13, 6, 0, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = '#7c3aed';
    ctx.beginPath(); ctx.ellipse(sx, furnitureY + 14, 11, 5, 0, 0, Math.PI * 2); ctx.fill();
  };
  drawStool(barX - 52);
  drawStool(barX);
  drawStool(barX + 52);

  // === BARTENDER "RIO" ===
  const bx = barX;
  const by = furnitureY - 62;
  ctx.fillStyle = `rgba(253, 224, 71, ${0.08 + glow * 0.06})`;
  ctx.beginPath(); ctx.arc(bx, by + 10, 34, 0, Math.PI * 2); ctx.fill();
  // torso / vest
  ctx.fillStyle = '#141420';
  ctx.beginPath(); ctx.ellipse(bx, by + 18, 15, 21, 0, 0, Math.PI * 2); ctx.fill();
  // shirt
  ctx.fillStyle = '#f2f2f2';
  ctx.beginPath();
  ctx.moveTo(bx - 6, by + 4); ctx.lineTo(bx + 6, by + 4);
  ctx.lineTo(bx + 4, by + 30); ctx.lineTo(bx - 4, by + 30);
  ctx.closePath(); ctx.fill();
  ctx.fillStyle = '#141420';
  ctx.fillRect(bx - 9, by + 4, 4, 26);
  ctx.fillRect(bx + 5, by + 4, 4, 26);
  // arms + shaking cocktail shaker
  const shake = Math.sin(phase * 0.15) * 4;
  ctx.fillStyle = '#141420';
  ctx.fillRect(bx - 22, by + 8, 10, 5);
  ctx.fillRect(bx + 12, by + 4 + shake * 0.6, 10, 5);
  ctx.fillStyle = '#cfd4dc';
  ctx.fillRect(bx + 20, by - 4 + shake, 8, 16);
  ctx.fillStyle = '#9aa1ab';
  ctx.fillRect(bx + 21, by - 9 + shake, 6, 6);
  // head, hair, face, bowtie
  ctx.fillStyle = '#d4a574';
  ctx.beginPath(); ctx.arc(bx, by - 8, 11, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = '#141420';
  ctx.beginPath(); ctx.arc(bx, by - 11, 10, Math.PI, 0, false); ctx.fill();
  ctx.fillStyle = '#2a2a2a';
  ctx.fillRect(bx - 5, by - 10, 2, 2);
  ctx.fillRect(bx + 3, by - 10, 2, 2);
  ctx.strokeStyle = '#2a2a2a';
  ctx.lineWidth = 1.2;
  ctx.beginPath(); ctx.arc(bx, by - 5, 4, 0.15 * Math.PI, 0.85 * Math.PI); ctx.stroke();
  ctx.fillStyle = '#dc2626';
  ctx.beginPath();
  ctx.moveTo(bx - 6, by + 4); ctx.lineTo(bx, by + 7); ctx.lineTo(bx + 6, by + 4); ctx.lineTo(bx, by + 1);
  ctx.closePath(); ctx.fill();
  // name tag
  ctx.font = 'bold 10px sans-serif';
  ctx.textAlign = 'center';
  ctx.fillStyle = '#fde047';
  ctx.fillText('RIO', bx, by + 42);

  // floating TAP TO ORDER pill
  const pulse = 0.65 + Math.sin(phase * 0.06) * 0.35;
  const bw = 100, bh = 18;
  const byy = by - 40 + Math.sin(phase * 0.05) * 2;
  ctx.fillStyle = `rgba(0,0,0,${0.55 * pulse + 0.25})`;
  ctx.beginPath(); ctx.roundRect(bx - bw / 2, byy - bh + 4, bw, bh, 9); ctx.fill();
  ctx.strokeStyle = `rgba(253, 224, 71, ${pulse})`;
  ctx.lineWidth = 1.5;
  ctx.beginPath(); ctx.roundRect(bx - bw / 2, byy - bh + 4, bw, bh, 9); ctx.stroke();
  ctx.font = 'bold 10px sans-serif';
  ctx.fillStyle = `rgba(253, 224, 71, ${0.75 + pulse * 0.25})`;
  ctx.fillText('🍹 TAP TO ORDER', bx, byy);
};

// Whole bar area is tappable — counter, shelves and Rio
export const getBartenderHitbox = (W, H, floorY) => {
  const furnitureY = floorY + 60;
  const barX = W * 0.79;
  return { x: barX - 100, y: furnitureY - 150, width: 200, height: 200 };
};
